import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from '@wix/da-shared-react/pkg/GallectionFolderDropdown';
import { AppState } from '../../../../../../../types/store';
import { setSelectedFolderId } from '../../../../../../actions/gallectionSection';
import {
  getOrderedNonEmptyFolders,
  getTotalDeviationsPerFolders,
} from '../../../../../../selectors/folders';

export type StateProps = Pick<Props, 'folders' | 'foldersDeviationCount'>;
export type DispatchProps = Pick<Props, 'setSelectedFolderId'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const folders = getOrderedNonEmptyFolders(state);
  const foldersDeviationCount = getTotalDeviationsPerFolders(state);

  return {
    folders,
    foldersDeviationCount,
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setSelectedFolderId,
};

export default connect(mapStateToProps, mapDispatchToProps);
